module.exports = __webpack_public_path__ + "static/media/mildred_img_2.8464db92.jpg";